import View from '../../../../../../View'
import {HIDE_ANIMATION_CLASSES, PANEL_TYPES, SHOW_ANIMATION_CLASSES} from '../../../../../../panels/constants'
import LoadingContainer from '../../../../../../util/LoadingContainer'
import PanelContainer from '../../../../../../components/PanelContainer'
import {connect} from '../../../../../../redux/utils'
import {bindActionCreators} from 'redux'
import {isImportHolidaysInProcess, isLoadingImportedHolidays, isShownImportHolidaysPanel} from '../selectors'
import {closePanel} from '../actions'
import ImportHolidaysPanelContent from './ImportHolidaysPanelContent'

class ImportHolidaysPanelContainer extends View {
    constructor({
        closePanel
    }) {
        super()

        this.actions = {
            closePanel
        }

        this.state = {
            isShown: false,
            loading: false,
            importProcess: false,
        }

        this.onAnyStatePropertyChanged(['loading', 'importProcess'], () => {
            this.loadingContainer.setState({
                loading: this.state.loading || this.state.importProcess,
            })
            this.panelContainerWrapper.getEl().toggleClass('importProcess', this.state.importProcess)
        })

        this.onStatePropertyChanged('isShown', (isShown) => this.panelContainerWrapper.setState({isShown}))
    }

    afterRender() {
        this.loadingContainer = new LoadingContainer({
            contentComponent: new ImportHolidaysPanelContent(),
            containerClass: "loading_importHolidaysPanel",
            loadingMoireConfig: {
                delay: 100
            },
        })

        this.panelContainerWrapper = new PanelContainer({
            component: this.loadingContainer,
            additionalClass: 'importHolidaysPanel',
            showAnimationClass: SHOW_ANIMATION_CLASSES.SLIDE_LEFT,
            hideAnimationClass: HIDE_ANIMATION_CLASSES.SLIDE_LEFT,
            hideOnEsc: true,
            showHideButton: true,
            onHideCallback: () => this.actions.closePanel(),
            hideOnClickOutside: {
                hideOnClick: true,
                panelType: PANEL_TYPES.IMPORT_HOLIDAYS_PANEL,
            },
            onClickCloseButton: () => this.actions.closePanel(),
        }).init(this.$containerEl)
    }
}

export default connect(
    state => ({
        isShown: isShownImportHolidaysPanel(state),
        loading: isLoadingImportedHolidays(state),
        importProcess: isImportHolidaysInProcess(state),
    }),
    dispatch => ({
        closePanel: bindActionCreators(closePanel, dispatch),
    }),
)(ImportHolidaysPanelContainer)



// WEBPACK FOOTER //
// ./web/js/administration/workSchedule/components/panels/importHolidays/components/ImportHolidaysPanelContainer.js